import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import {BrowserRouter} from "react-router";
import {Provider} from "react-redux";
import {store} from "@/store";
import posthog from 'posthog-js';
import {PostHogErrorBoundary, PostHogProvider} from '@posthog/react';
import * as Sentry from "@sentry/react";


posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    defaults: '2026-01-30',
});


Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true
});


createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <PostHogProvider client={posthog}>
            <PostHogErrorBoundary>
                <Provider store={store}>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </Provider>
            </PostHogErrorBoundary>
        </PostHogProvider>
    </StrictMode>,
)
